import { createContext, type ReactNode, useContext, useMemo } from 'react';
import type { Section } from '../configurations/types';

interface CoverSheetContextInterface {
  section: Section;
}

const CoverSheetSectionContext = createContext<CoverSheetContextInterface>({
  section: {} as Section,
});

export function useCoverSheetSectionContext() {
  return useContext(CoverSheetSectionContext);
}

interface Props {
  children: ReactNode;
  section: Section;
}

export const CoverSheetSectionProvider = ({ children, section }: Props) => {
  const contextValue = useMemo<CoverSheetContextInterface>(
    () => ({ section }),
    [section],
  );

  return (
    <CoverSheetSectionContext.Provider value={contextValue}>
      {children}
    </CoverSheetSectionContext.Provider>
  );
};
